var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatrol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 689,
    y: 240,
    width: 38,
    height: 38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.309009,
    y: -9523.55,
    width: 361905,
    height: 371429
  })), /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 41,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 361904,
    height: 353287
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-689 -240)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000105 0 0 0.000105 689 240)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1 0 0 1.02439 -0.124767 0.0062314)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(8616.76 8616.76)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatrol);
export default __webpack_public_path__ + "static/media/Patrol.c80a4979a3cdf2cae1f5f536759978b9.svg";
export { ForwardRef as ReactComponent };